module.exports = __webpack_public_path__ + "img/img1.c75da03a.png";